(function () {
  var money = function (c) {
    return (window.Shopify && Shopify.currency ? '' : '') + (c / 100).toFixed(2);
  };

  /* ---------- cart drawer ---------- */
  function drawer() { return document.getElementById('CartDrawer'); }
  function openDrawer() { var d = drawer(); if (d) { d.hidden = false; document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { var d = drawer(); if (d) { d.hidden = true; document.body.style.overflow = ''; } }

  function refreshCart() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        var cur = drawer();
        if (fresh && cur) {
          var wasOpen = !cur.hidden;
          cur.innerHTML = fresh.innerHTML;
          cur.hidden = !wasOpen;
        }
        var count = tmp.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (count) el.textContent = count.textContent;
        });
      });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var change = e.target.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.lineChange) })
      }).then(refreshCart);
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentNode.querySelector('input[name="quantity"]');
      if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep));
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- hero rotator ---------- */
  var hero = document.querySelector('[data-hero]');
  if (hero) {
    var slides = [].slice.call(hero.querySelectorAll('[data-hero-slide]'));
    var dots = [].slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var rings = [].slice.call(hero.querySelectorAll('[data-hero-ring]'));
    var i = 0, timer;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var src = slides[i];
      rings.forEach(function (r, k) {
        r.style.background = src.dataset['c' + (k + 1)] || r.style.background;
      });
    }
    function start() { timer = setInterval(function () { show(i + 1); }, 4200); }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { clearInterval(timer); show(k); start(); });
    });
    if (slides.length) { show(0); start(); }
  }

  /* ---------- scent finder ---------- */
  var quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    var steps = [].slice.call(quiz.querySelectorAll('[data-quiz-step]'));
    var results = [].slice.call(quiz.querySelectorAll('[data-quiz-result]'));
    var bar = quiz.querySelector('[data-quiz-bar]');
    var counter = quiz.querySelector('[data-quiz-counter]');
    var picks = [], step = 0;

    function render() {
      steps.forEach(function (s, k) { s.hidden = k !== step || step >= steps.length; });
      results.forEach(function (r) { r.hidden = true; });
      if (bar) bar.style.width = Math.round((step / steps.length) * 100) + '%';
      if (counter) counter.textContent = 'Question ' + Math.min(step + 1, steps.length) + ' of ' + steps.length;
      if (step >= steps.length) {
        var tally = {};
        picks.forEach(function (p) { tally[p] = (tally[p] || 0) + 1; });
        var best = Object.keys(tally).sort(function (a, b) { return tally[b] - tally[a]; })[0];
        var match = results.filter(function (r) { return r.dataset.quizResult === best; })[0] || results[0];
        if (match) match.hidden = false;
        if (bar) bar.style.width = '100%';
        if (counter) counter.textContent = 'Your match';
      }
    }
    quiz.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-quiz-pick]');
      if (opt) { picks.push(opt.dataset.quizPick); step++; render(); }
      if (e.target.closest('[data-quiz-reset]')) { picks = []; step = 0; render(); }
    });
    render();
  }
})();
